import React, { useEffect, useState } from "react";
import {
    Grid,
    Drawer,
    IconButton,
    List,
    ListItem,
    ListItemText,
    useMediaQuery,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { Link, useNavigate } from "react-router-dom";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { API_URL } from "../config";
import logo from "../assets/logo.svg";
import axios from "axios";

export default function Header() {
    const [name, setName] = useState("");
    const [admin, setAdmin] = useState(0);
    const [departments, setDepartments] = useState([]);
    const [mobileOpen, setMobileOpen] = useState(false);
    const [isMobileBransOpen, setMobileBransOpen] = useState(false);
    const [isBransDropdownOpen, setBransDropdownOpen] = useState(false);
    const isMobile = useMediaQuery("(max-width:768px)");
    const navigate = useNavigate();
    const [isUserDropdownOpen, setUserDropdownOpen] = useState(false);
    useEffect(() => {
        axios
            .get(`${API_URL}/department-list`)
            .then((response) => {
                setDepartments(response.data.departments);
            })
            .catch((error) => {
                console.error("Departmanları alırken hata:", error);
            });
    }, []);

    useEffect(() => {
        setName(JSON.parse(localStorage.getItem("ac_name")));
        let permissions = JSON.parse(localStorage.getItem("ac_permissions"));
        setAdmin(permissions?.admin);
    }, []);

    const handleLogout = () => {
        confirmAlert({
            title: "Çıkış",
            message: "Oturumu kapatmak istediğinize emin misiniz?",
            buttons: [
                {
                    label: "Evet",
                    onClick: async () => {
                        await localStorage.clear();
                        navigate("/");
                        window.location.reload();
                    },
                },
                {
                    label: "Hayır",
                    onClick: () => {},
                },
            ],
        });
    };

    const toggleBransDropdown = () => {
        setBransDropdownOpen(!isBransDropdownOpen);
    };

    const drawer = (
        <div style={{ width: 250, padding: 20 }}>
            <List>
                <ListItem button component={Link} to="/main" onClick={() => setMobileOpen(false)}>
                    <ListItemText primary="Ana Sayfa" />
                </ListItem>

                {/* Branşlar Açılır Menü */}
                <ListItem button onClick={() => setMobileBransOpen(!isMobileBransOpen)}>
                    <ListItemText primary={`Branşlar ${isMobileBransOpen ? "▲" : "▼"}`} />
                </ListItem>
                {isMobileBransOpen && (
                    <div style={{ maxHeight: "200px", overflowY: "auto", paddingLeft: 16 }}>
                        {departments.map((dep, idx) => (
                            <ListItem
                                button
                                key={idx}
                                component={Link}
                                to={`/doctor-list/${dep}`}
                                onClick={() => setMobileOpen(false)}
                            >
                                <ListItemText primary={dep} />
                            </ListItem>
                        ))}
                    </div>
                )}
                {name ? (
                    <>
                        <ListItem button component={Link} to="/doctor/dashboard" onClick={() => setMobileOpen(false)}>
                            <ListItemText primary="Tarihler" />
                        </ListItem>
                        <ListItem button component={Link} to="/doctor/profile-settings" onClick={() => setMobileOpen(false)}>
                            <ListItemText primary="Profil Düzenle" />
                        </ListItem>
                        <ListItem button component={Link} to="/doctor/password-change" onClick={() => setMobileOpen(false)}>
                            <ListItemText primary="Şifre Değiştir" />
                        </ListItem>
                        {admin > 0 && (
                            <ListItem button component={Link} to="/user-manage" onClick={() => setMobileOpen(false)}>
                                <ListItemText primary="Kullanıcılar" />
                            </ListItem>
                        )}
                        <ListItem button onClick={() => { setMobileOpen(false); handleLogout(); }}>
                            <ListItemText primary="Çıkış" />
                        </ListItem>
                    </>
                ) : (
                    <ListItem button component={Link} to="/login" onClick={() => setMobileOpen(false)}>
                        <ListItemText primary="Giriş" />
                    </ListItem>
                )}
            </List>
        </div>
    );

    return (
        <header className="App-header">
            <Grid container alignItems="center" justifyContent="space-between" style={{ padding: "10px 20px" }}>
                <Grid item>
                    <a href={'/'}>
                        <img src={logo} alt="logo" style={{height: 50}}/>
                    </a>


                </Grid>

                {isMobile ? (
                    <Grid item>
                        <IconButton onClick={() => setMobileOpen(true)}>
                            <MenuIcon  style={{color:'white'}}/>
                        </IconButton>
                        <Drawer anchor="right" open={mobileOpen} onClose={() => setMobileOpen(false)}>
                            {drawer}
                        </Drawer>
                    </Grid>
                ) : (
                    <Grid item>
                        <nav style={{ display: "flex", gap: 20, alignItems: "center", position: "relative" }}>
                            <Link to="/main">Ana Sayfa</Link>

                            <div className="bransMenu" style={{ position: "relative" }}>
                <span onClick={toggleBransDropdown} style={{ cursor: "pointer" }}>
                  Branşlar ▼
                </span>
                                {isBransDropdownOpen && (
                                    <div
                                        style={{
                                            position: "absolute",
                                            top: "100%",
                                            left: 0,
                                            background: "white",
                                            border: "1px solid #ccc",
                                            zIndex: 1000,
                                            minWidth: "150px",
                                            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                                        }}
                                    >
                                        {departments.map((dep, idx) => (
                                            <Link
                                                key={idx}
                                                to={`/doctor-list/${dep}`}
                                                className="dropdown-link"
                                                style={{
                                                    display: "block",
                                                    padding: "8px 12px",
                                                    textDecoration: "none",
                                                    color: "#000",
                                                }}
                                            >
                                                {dep}
                                            </Link>
                                        ))}
                                    </div>
                                )}
                            </div>

                            {name ? (
                                <div className="userMenu" style={{position: "relative"}}>
  <span onClick={() => setUserDropdownOpen(!isUserDropdownOpen)} style={{cursor: "pointer"}}>
    {name} ▼
  </span>
                                    {isUserDropdownOpen && (
                                        <div
                                            className="dropdown"
                                            style={{
                                                position: "absolute",
                                                top: "100%",
                                                right: 0,
                                                background: "white",
                                                border: "1px solid #ccc",
                                                zIndex: 1000,
                                                minWidth: "150px",
                                                boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                                            }}
                                        >
                                            <Link to="/doctor/dashboard" className="dropdown-link"
                                                  style={dropdownStyle}>Tarihler</Link>
                                            <Link to="/doctor/profile-settings" className="dropdown-link"
                                                  style={dropdownStyle}>Profil Düzenle</Link>
                                            <Link to="/doctor/password-change" className="dropdown-link"
                                                  style={dropdownStyle}>Şifre Değiştir</Link>
                                            {admin > 0 && (
                                                <Link to="/user-manage" className="dropdown-link"
                                                      style={dropdownStyle}>Kullanıcılar</Link>
                                            )}
                                            <Link onClick={handleLogout} className="dropdown-link"
                                                  style={dropdownStyle}>Çıkış</Link>
                                        </div>
                                    )}
                                </div>
                            ) : (
                                <Link to="/login">Giriş</Link>
                            )}
                        </nav>
                    </Grid>
                )}
            </Grid>
        </header>
    );
}

const dropdownStyle = {
    display: "block",
    padding: "8px 12px",
    textDecoration: "none",
    color: "#000",
};